export const state = {
  filters: []
}
